import { render, staticRenderFns } from "./CommentCell.vue?vue&type=template&id=6c30c50f&scoped=true&"
import script from "./CommentCell.vue?vue&type=script&lang=ts&"
export * from "./CommentCell.vue?vue&type=script&lang=ts&"
import style0 from "./CommentCell.vue?vue&type=style&index=0&id=6c30c50f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c30c50f",
  null
  
)

export default component.exports